import { IAppState } from '../../redux';

export const selectIsDealRent = (state: IAppState): boolean => {
  const { offer } = state;

  return offer.status === 'published' &&
    !!offer.flags?.isDealRent;
};
